import Theme from '../../theme';
import React, { PureComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { moderateScale } from 'react-native-size-matters';

interface IProps {
  icon: JSX.Element;
  value: number | undefined;
  borderLeft?: boolean;
  borderRight?: boolean;
  heartRateZoneColour?: string;
  isLandscape: boolean;
  name: string;
}

export class Metric extends PureComponent<IProps, any> {
  public render() {
    const { icon, value = '-', heartRateZoneColour = Theme.WHITE, borderLeft = false, borderRight = true } = this.props;
    if (this.props.isLandscape) {
      return (
        <View style={[
          styles.container,
          borderLeft && styles.borderLeft,
          borderRight && styles.borderRight,
        ]}>
          {icon}
          <Text style={[styles.value, { color: heartRateZoneColour }]}>{value}</Text>
        </View>
      );
    }
    return (
      <View style={[
        styles.container,
        borderLeft && styles.borderLeft,
        borderRight && styles.borderRight,
        styles.containerPortrait,
      ]}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {icon}
          <Text style={[styles.value, { color: heartRateZoneColour }, styles.valuePortrait]}>{value}</Text>
        </View>
        <View>
          <Text style={styles.metricName}>{this.props.name}</Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: Theme.GREY_MEDIUM,
    width: moderateScale(54),
  },
  containerPortrait: {
    flex: 1,
    justifyContent: 'center',
    borderColor: Theme.GREY_DARK,
    paddingVertical: moderateScale(5),
  },
  borderLeft: {
    borderLeftWidth: 1,
  },
  borderRight: {
    borderRightWidth: 1,
  },
  value: {
    fontSize: moderateScale(19),
    color: Theme.WHITE,
    fontFamily: Theme.Custom700,
  },
  valuePortrait: {
    fontSize: moderateScale(24),
    lineHeight: moderateScale(24),
    marginLeft: 5,
  },
  metricName: {
    fontSize: moderateScale(8),
    color: Theme.GREY_MEDIUM,
    fontFamily: Theme.Custom700,
  },
});
